export class BecomeColumnistPopup {
  constructor() {
    this.popup = document.querySelector('.become-columnist-popup');
    this.openBtns = document.querySelectorAll('.become-columnist-block__btn');
    this.closeBtn = this.popup?.querySelector('.become-columnist-popup__close');

    this.init();
  }

  init() {
    if (!this.popup || !this.openBtns.length) return;

    // Add click handlers to all open buttons
    this.openBtns.forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    this.closeBtn?.addEventListener('click', () => this.close());

    // Close on outside click
    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.close();
      }
    });
  }

  open() {
    this.popup.classList.add('become-columnist-popup_active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.popup.classList.remove('become-columnist-popup_active');
    document.body.style.overflow = '';
  }
} 